<template>
  <div>
    <div class="table-wapper" ref="toolbarTable">
    <table :key="keyTable">
      <thead>
        <tr class="tittle-table">
          <th>{{ $t('order_number') }}</th>
          <th>{{ $t('date') }}</th>
          <th>{{ $t('outlet_register') }}</th>
          <th>{{ $t('customer_name') }}</th>
          <th>{{ $t('duration_day') }}</th>
        </tr>
      </thead>
      <tbody v-if="itemsLength() > 0">
        <!-- <tr class="total-rows total_report">
          <td>{{ $t('summary') }}</td>
          <td class="text-right" v-for="(colName, index) in colsData" :key="index">{{ totalPriceByCol(colName.key || colName) }}</td>
        </tr> -->
        <tr v-for="(item, index) in removeAverage()" :key="index">
          <td>{{ report.items[item].order_number }}</td>
          <td>{{ formartDate(report.items[item].created_at) }}</td>
          <td>{{ getOutletRegisterName(report.items[item].outlet_id, report.items[item].register_id) }}</td>
          <td>{{ getCustomerName(report.items[item].first_name, report.items[item].last_name) }}</td>
          <td>{{ getDuration(report.items[item].avg_duration) }}</td>
        </tr>
      </tbody>
      <tbody v-if="itemsLength() <= 0">
        <tr class="no-data">
          <td colspan="12">{{$t('no_data')}}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="pagination" v-if="count_items / getQuery.limit > 1">
    <Pagination :page="getQuery.page - 1" :total="count_items" :limit="getQuery.limit" @getDataTable="getDataTable"/>
  </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import reportType from '@/config/reportType'
import moment from 'moment'
// import currencyFormatter from 'currency-formatter'
import formatNum from 'format-num'
import { getItemByLocalStorage } from '@/utils/localStorage'
import localStorageKey from '@/constants/localStorageKey'
import Pagination from '@/components/UiPagination'
import i18n from '@/i18n'
export default {
  name: 'UiTableOrderDurationReport',
  components: {
    Pagination
  },
  props: {
    report: {
      type: Object,
      default: () => {}
    },
    colsData: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      groupedData: [],
      conferenceDay: [],
      reportType: {
        productSold: 'productSold',
        productSoldByCategory: 'productSoldByCategory',
        payment: 'payment'
      },
      keyTable: 0
    }
  },
  computed: {
    ...mapGetters({
      getListOutLet: 'outlet/getListOutLet',
      getCustomStatuses: 'order/getCustomStatuses',
      count_items: 'report/getCountItems',
      getQuery: 'report/getQuery',
      getIsChangeStore: 'report/getIsChangeStore'
    })
  },
  watch: {
    getQuery: function (news, old) {
      if (news.page !== old.page) {
        this.$refs.toolbarTable.scrollTop = 0
      }
      if (!this.getIsChangeStore) {
        this.report.items = []
      }
      this.keyTable = Math.random()
      this.setChangeStore(false)
    }
  },
  methods: {
    ...mapActions({
      getReport: 'report/getReportDataByStore',
      setChangeStore: 'report/setChangeStore'
    }),
    moment (any) {
      return moment(any)
    },
    getName () {
      return this.$route.currentRoute.name
    },
    removeAverage () {
      return Object.keys(this.report.items).filter(e => e !== '0')
    },
    getTableData (reportItem, col) {
      if (typeof reportItem === 'string') {
        return this.formatTotal(this.report.items[reportItem][col])
      }
      if (typeof reportItem[col] === 'string' || typeof reportItem[col] === 'number') {
        return this.formatTotal(reportItem[col])
      }
      return col.key === 'orderCount'
        ? reportItem[col.key] || 0
        : col.key === 'avgItemCount'
          ? reportItem[col.key]
            ? parseFloat(reportItem[col.key]).toFixed(2)
            : 0
          : this.formatTotal(reportItem[col.key])
    },
    onChangeOutlet (reportingMode, outletIds, registerIds, day, type, states, statuses) {
      this.day = day
      this.query.outletIds = outletIds
      this.query.registerIds = registerIds
      this.query.reportingMode = reportingMode
      this.filterType = type
      this.query.mode = type
      this.getReport({
        type: reportType.saleSummary,
        query: {
          ...this.query,
          ...day
        }
      })
    },
    onDefaultFilter (day, type) {
      this.day = day
      this.filterType = type
      this.query.mode = type
      this.getReport({
        type: reportType.saleSummary,
        query: {
          ...this.query,
          ...day
        }
      })
    },
    formartDate (date) {
      if (!date) {
        return ''
      }
      if (date.length < 8) {
        if (date.toLowerCase().includes('week')) {
          return date.toLowerCase().replace('week', i18n.t('week'))
        }
        return date
      }
      const dateRes = new Date(moment(date.replace('Z', '')).toDate())

      return i18n.d(dateRes, 'short')
    },
    getPlatform () {
      return getItemByLocalStorage(localStorageKey.CURRENT_PLATFORM)
    },
    formatTotal (total) {
      const storeConfig = getItemByLocalStorage(localStorageKey.STORE_CONFIG)
      const currentCurrent = getItemByLocalStorage(localStorageKey.CURRENT_CURRENCY)
      return `${currentCurrent?.symbol || storeConfig.symbol} ${formatNum((Number(total) * Number(currentCurrent?.rate || '1')).toFixed(2), { maxFraction: 2 })}`
    },
    totalPaymentByCol (colName) {
      if (this.report === undefined || this.report.items === undefined) {
        return this.formatTotal(0)
      }

      let total = 0
      Object.keys(this.report.items).forEach((item) => {
        total += parseFloat(this.report.items[item][colName] ? parseFloat(this.report.items[item][colName]) : 0)
      })

      return this.formatTotal(total)
    },
    totalPriceByCol (colName) {
      if (this.report === undefined || this.report.items === undefined) {
        return this.formatTotal(0)
      }

      if (colName === 'avgOrderValue') {
        let totalRevenue = 0
        let totalOrder = 0
        Object.keys(this.report.items).forEach(item => {
          totalRevenue += parseFloat(this.report.items[item].totalRevenue ? parseFloat(this.report.items[item].totalRevenue) : 0)
          totalOrder += parseFloat(this.report.items[item].orderCount ? parseFloat(this.report.items[item].orderCount) : 0)
        })
        return this.formatTotal(totalRevenue / totalOrder)
      }

      let total = 0
      Object.keys(this.report.items).forEach((item) => {
        total += parseFloat(this.report.items[item][colName] ? parseFloat(this.report.items[item][colName]) : 0)
      })
      if (colName === 'avgOrderValue' || colName === 'avgItemCount') {
        const avgValue = (total / Object.keys(this.report.items).length).toFixed(2)
        return colName === 'avgOrderValue' ? this.formatTotal(avgValue) : avgValue
      }
      return colName === 'orderCount' ? total : this.formatTotal(total)
    },
    itemsLength () {
      if (this.report === undefined || this.report.items === undefined) {
        return 0
      }

      let total = 0
      Object.keys(this.report.items).forEach((item) => {
        total += 1
      })
      return total
    },
    getOutletRegisterName (outletId, registerId) {
      const outlet = this.getListOutLet.find((outlet) => outlet.id === outletId)
      if (outlet) {
        const outletName = outlet.name

        const register = (outlet.registers || []).find(registerObj => registerObj.id === registerId)

        return outletName + (register ? (' - ' + register.name) : '')
      }
      return ''
    },
    getCustomerName (firstName, lastName) {
      if (!firstName) {
        return ''
      }
      return firstName + (lastName ? ` ${lastName}` : '')
    },
    getDuration (duration) {
      const avg = Number(duration)
      return (avg > 9 ? '' : '0') + avg.toFixed(2)
    },
    groupBy (array, fn) {
      const result = {}
      array.forEach((item) => {
        const key = fn(item)

        if (!result[key]) {
          result[key] = []
        }
        result[key].push(item)
      })
      return result
    },
    getDataTable (currentPage) {
      this.getReport({
        type: reportType.averageDuration,
        query: {
          ...this.query,
          page: currentPage
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.table-wapper {
  overflow-x: auto;
  table {
    width: 100%;
    color: #333;
    border: 0 solid #e4e3e4;
    border-collapse: collapse;
    border-spacing: 0;
    background-color: #fff;
    border-width: 1px 0 0 1px;
    border-radius: 7px;
    letter-spacing: 0;
    font-size: 15px;
    font-weight: 400;
    td,
    tr,
    th {
      border: 1px solid #e4e3e4;
      padding: 15px 5px;
      vertical-align: middle;
    }
    tr td:first-child {
      text-transform: capitalize;
    }
    .tittle-table {
      color: #fff;
      background-color: #92a1ab;
      border-top-left-radius: 7px;
      border-top-right-radius: 7px;
      th {
        font-size: 16px;
        font-weight: bold;
        text-transform: capitalize;
        border-bottom-width: 1px;
        text-align: center;
        padding: 15px 5px;
        border: 1px solid #e4e3e4;
        vertical-align: middle;
      }
    }
    .text-center {
      text-align: center;
    }
    .text-right {
      text-align: right;
    }
    .min_width {
      min-width: 150px;
    }
    .report_name {
      min-width: 230px;
    }
    .report_total {
      width: 100px;
    }
    .text-capitalize {
      text-transform: capitalize;
    }
  }
}
</style>
